<template>
  <div id="app">
    <div class="headimg"><img src="./assets/header1.png"></div>
      <div class="hello">
        <LeftThree class="dblock" style="width: 24%;margin-right:1%;"></LeftThree>
          <CenterTwo class="oncenter"></CenterTwo>
      </div>
    </div>
</template>
<script>
import LeftThree from './components/LeftThree'
import CenterTwo from './components/CenterTwo'
export default {
  name: 'App',
  components: {
    LeftThree,
    CenterTwo
  },
  created() {
    document.body.removeChild(document.getElementById('Loading'))
  }
}

</script>
<style>
#app {
  font-family: '微软雅黑', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  background: url(http://bi.oillink.com/screendata/static/img/bg.png) no-repeat;
  background-size: 100% 100%;
}

.hello {
  padding: 2%;
  width: 100%;
  height: 87.24%;
  box-sizing: border-box;
  display: flex;
  position: absolute;
  top: 12.76%;
}

.headimg {
  height: 12.76%;
  width: 100%;
  z-index: 5;
  position: fixed;
  top: 0;
}

.headimg img {
  width: 100%;
}

.oncenter {
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dblock {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/App.vue